export const POSTCODE_REGEX = /^[A-Z]{1,2}\d{1,2}[A-Z]{0,1} ?\d[A-Z]{2}$/i;
const POSTCODE_MIN_LENGTH = 5;
const POSTCODE_MAX_LENGTH = 7;

export const validatePostcode = (value: string): boolean => {
    if (!value) {
        return false;
    }

    const cleanedValue = value.trim().replace(/\s/g, "");
    if (cleanedValue.length < POSTCODE_MIN_LENGTH || cleanedValue.length > POSTCODE_MAX_LENGTH) {
        return false;
    }

    const isValid = POSTCODE_REGEX.test(cleanedValue);

    return isValid;
};
